import * as service from "../service";
import { store } from "../../store";

export type BusinessProfile = Record<string, any>;

/** Legacy, unpaginated payload (every row). */
export type GetAllBusinessesResult = BusinessProfile[];

export type GetAllBusinessesParams = {
  page?: number;
  size?: number;
  q?: string;
  active?: "all" | "active" | "inactive";
  review_status?: "all" | "pending" | "approved" | "rejected";
};

export type GetAllBusinessesPagedResult = {
  /** One page of rows, already filtered/sorted by the server. */
  data: BusinessProfile[];
  /** Rows matching the active search + filters (not the page size). */
  total: number;
  /** Every business, ignoring search + filters. Backs the tab label / stat card. */
  overallTotal: number;
  /** Population-wide review queue counts, ignoring search + filters. */
  reviewTotals?: { pending: number; approved: number; rejected: number };
  page: number;
  size: number;
  hasMore: boolean;
};

/**
 * Fetch business information (admin only).
 * Backend: GET /api/business/getAllBusinesses (admin check via `user_id` query param)
 *
 * Called without `params` it keeps the legacy whole-list behaviour for callers
 * that iterate every row. Pass `params` to opt into server-side pagination and
 * filtering, which is what bounded payloads need.
 */
export const GetAllBusinessesAPI = async (
  params?: GetAllBusinessesParams,
): Promise<any> => {
  try {
    const admin = store.getState().auth.admin;
    const resp = await service.call(
      "GET",
      "/api/business/getAllBusinesses",
      {
        user_id: admin.id,
        ...(params ? { scope: "page" } : {}),
        ...(params?.q ? { q: params.q } : {}),
        ...(params?.page ? { page: params.page } : {}),
        ...(params?.size ? { size: params.size } : {}),
        ...(params?.active && params.active !== "all" ? { active: params.active } : {}),
        ...(params?.review_status && params.review_status !== "all"
          ? { review_status: params.review_status }
          : {}),
      },
    );
    return resp;
  } catch (err) {
    console.error(`GetAllBusinessesAPI ${err}`);
    return { status: -1, resp: err };
  }
};
